export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-200 dark:before:bg-gray-700",
  header: "px-0 py-1",
  title: "text-theme-xl font-semibold text-gray-800 dark:text-white/90",
  tableCard:
    "bg-white dark:bg-gray-800 p-0 rounded-lg mt-6 sm:mt-9 border border-gray-200 dark:border-gray-700 overflow-hidden",
  headerControls:
    "flex flex-col sm:flex-row justify-between items-center p-3 sm:p-4 border-b border-white dark:border-gray-700 bg-white dark:bg-gray-800 gap-3 sm:gap-4",
  controlsInner:
    "flex flex-wrap md:flex-nowrap items-center w-full md:w-auto gap-2 md:gap-2",
  searchContainer: "relative flex items-center flex-1 w-full h-10",
  searchInput:
    "dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-11 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 md:w-[180px] xl:w-[200px]",
  searchIcon: "absolute left-3 text-gray-400 dark:text-gray-300 w-4 h-4",
  downloadButton:
    "inline-flex items-center justify-center rounded-lg transition px-4 py-2 md:py-3 text-sm bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300",
  downloadIcon: "w-5 h-5 ml-1.5",
  addButtonContainer: "w-full sm:w-auto",
  addButton: 
    "inline-flex items-center justify-center gap-1 md:gap-2 rounded-md md:rounded-lg transition px-3 py-2 md:px-4 md:py-3 text-xs md:text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white shadow-theme-xs hover:bg-[#2779bd] dark:hover:bg-[#335877] disabled:bg-brand-300 w-full md:w-auto",
  errorText: "text-red-500 text-xs",
  tableContainer: "overflow-x-auto max-h-[500px] block", 
  table: "w-full border-collapse table-auto min-w-[600px] border-separate border-spacing-0",
  theadRow: "sticky top-0 z-10 bg-white dark:bg-gray-900 text-left font-medium text-gray-700 theme-xs dark:text-gray-400 border-b border-gray-300 dark:border-gray-700",
  thName:
    "px-3 py-2 sm:px-4 sm:py-3 border border-gray-100 dark:border-white/[0.05] min-w-[120px]",
  thProfileImage:
    "w-[100px] min-w-[80px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05]", // Reduced width for tablet
  thEmail:
    "w-[200px] min-w-[140px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05]", // Adjusted for tablet
  thMobileNumber:
    "px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm min-w-[120px]",
  thRole:
    "px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm min-w-[100px]",
  thStatus:
    "px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm min-w-[100px]",
  thAction:
    "w-[80px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm",
  thLog:
    "w-[80px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm",
  thSortable: "flex items-center justify-between cursor-pointer",
  thText: "font-bold text-gray-800 text-theme-xs sm:text-theme-xs dark:text-gray-400",
  sortButton: "flex flex-col gap-0.5",
  tbodyRow: "border border-gray-100 dark:border-white/[0.05]",
  tdName:
    "px-2 py-2 sm:px-4 sm:py-3 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[180px] break-words",
  tdProfileImage:
    "w-[80px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05] cursor-pointer", // Adjusted for tablet
  profileImage: "w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover", // Slightly larger for tablet
  tdEmail:
    "w-[140px] px-2 py-2 sm:px-4 sm:py-3 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[180px] break-words", // Adjusted for tablet
  tdMobileNumber:
    "px-2 py-2 sm:px-4 sm:py-3 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] break-words",
  tdRole:
    "px-2 py-2 sm:px-4 sm:py-3 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[150px] break-words",
  tdStatus:
    "px-2 py-2 sm:px-4 sm:py-3 border border-gray-100 dark:border-white/[0.05]",
  tdAction:
    "w-[60px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05]",
  tdLog:
    "w-[60px] px-2 py-2 sm:px-3 sm:py-3 border border-gray-100 dark:border-white/[0.05]",
  statusContainer: "flex items-center gap-1.5",
  statusToggle:
    "w-8 h-4.5 rounded-full flex items-center px-0.5 transition-all",
  statusToggleActive: "bg-green-500 dark:bg-green-400",
  statusToggleInactive: "bg-red-500 dark:bg-red-400",
  statusToggleCircle:
    "w-3 h-3 bg-white rounded-full transition-transform",
  statusToggleCircleActive: "translate-x-4",
  statusToggleCircleInactive: "translate-x-0",
  statusBadge: "text-xs inline-flex items-center justify-center px-2.5 py-0.5 rounded-full",
  statusActive: "text-green-700 dark:text-green-300",
  statusInactive: " text-red-700 dark:text-red-300",
  actionContainer: "flex items-center space-x-1.5",
  editButton:
    "w-6 h-6 bg-[#2f6aa7] dark:bg-[#3d6794]  flex items-center justify-center rounded-md shadow hover:bg-[#2779bd] dark:hover:bg-[#335877] transition",
  deleteButton:
    "w-6 h-6 bg-red-600  dark:bg-red-400 flex items-center justify-center rounded-md shadow hover:bg-red-500 dark:hover:bg-red-600 transition",
  actionIcon: "w-3 h-3 md:w-4 md:h-4",
  loadingRow: "border-none",
  loadingText: "text-center text-gray-500 dark:text-gray-400 py-4 !border-0",
  noDataText: "text-center text-gray-500 dark:text-gray-400 py-4 !border-0",
  modal:
    "w-[90%] max-w-[360px] bg-white dark:bg-gray-900 px-5 py-5 rounded-lg shadow-xl mx-auto text-center relative", // Adjusted for tablet
  modalCloseButton:
    "absolute top-2.5 right-2.5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",
  modalIconContainer:
    "w-12 h-12 flex items-center justify-center bg-red-100 text-red-600 rounded-full",
  modalIcon: "w-5 h-5",
  modalTitle: "text-base font-bold text-gray-800 dark:text-white mt-3",
  modalText: "text-sm text-gray-500 dark:text-gray-400 mt-1.5",
  modalButtonContainer: "mt-5 flex justify-center gap-3",
  modalCancelButton:
    "px-3 py-1.5 border border-gray-300 text-gray-700 dark:text-white rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-700",
  modalDeleteButton: "px-3 py-1.5 bg-red-600 text-white rounded-md hover:bg-red-700",
};